var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTipsBag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 84,
    viewBox: "0 0 71 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M35.4679 42.1653L0 62.6442L35.4679 83.1232L71 62.6367L35.4679 42.1653Z",
    fill: "url(#paint0_linear_488_1113)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43315 29.5371L7.09277 54.5556L29.2685 67.3598V42.1447L7.43315 29.5371Z",
    fill: "url(#paint1_linear_488_1113)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43262 29.5373L10.3321 27.7725L32.1675 40.38L29.268 42.1449L7.43262 29.5373Z",
    fill: "#41DCEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.167 65.595L29.2676 67.3599V42.1448L32.167 40.3799V65.595Z",
    fill: "url(#paint2_linear_488_1113)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4419 6.90894L30.1016 31.9274L52.2773 44.7316V19.5165L30.4419 6.90894Z",
    fill: "url(#paint3_linear_488_1113)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4424 6.90917L33.3418 5.14429L55.1772 17.7519L52.2778 19.5167L30.4424 6.90917Z",
    fill: "#41DCEC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1758 42.9669L52.2764 44.7317V19.5166L55.1758 17.7517V42.9669Z",
    fill: "url(#paint4_linear_488_1113)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42708 1.12842L7.20898 17.1132L21.3772 25.2947V9.18385L7.42708 1.12842Z",
    fill: "url(#paint5_linear_488_1113)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42676 1.12827L9.27863 0L23.23 8.05543L21.3769 9.1837L7.42676 1.12827Z",
    fill: "#41DCEC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2301 24.1663L21.377 25.2945V9.18368L23.2301 8.05542V24.1663Z",
    fill: "url(#paint6_linear_488_1113)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5638 49.2842L38.3457 65.269L52.5139 73.4505V57.3396L38.5638 49.2842Z",
    fill: "url(#paint7_linear_488_1113)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5635 49.284L40.4153 48.1558L54.3667 56.2112L52.5136 57.3395L38.5635 49.284Z",
    fill: "#41DCEC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3668 72.3218L52.5137 73.4501V57.3392L54.3668 56.2109V72.3218Z",
    fill: "url(#paint8_linear_488_1113)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4933 18.9266C47.5169 19.3098 48.1031 20.1393 48.2027 21.4075C48.301 22.6757 47.8522 23.8002 46.9332 24.7167C46.6735 24.9638 46.3874 25.1756 46.1113 25.3886C45.1822 26.1185 44.2519 26.8484 43.3253 27.5632C42.8866 27.9023 42.395 27.8141 42.1945 27.3615C42.0092 26.943 42.1743 26.3858 42.5891 26.058C43.6783 25.2172 44.7712 24.3625 45.8642 23.5065C46.3811 23.0892 46.666 22.4602 46.6055 21.8324C46.5059 20.7495 45.4911 20.3221 44.625 21.0016C43.532 21.8576 42.4403 22.7123 41.3373 23.5657C40.9011 23.8897 40.4296 23.8053 40.2242 23.3829C40.0073 22.9581 40.1636 22.3845 40.5897 22.058C41.7054 21.192 42.811 20.3234 43.9279 19.4561C44.6389 18.9191 45.3764 18.7262 46.1882 18.8396C46.2613 18.8522 46.3849 18.8901 46.4971 18.9254L46.4933 18.9266Z",
    fill: "#E8F2FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1642 26.2965C36.1627 25.4859 37.1787 24.6942 38.2024 23.9189C38.7243 23.5332 39.3369 23.8584 39.3483 24.524C39.3521 24.9262 39.1756 25.2502 38.8629 25.4872C37.9338 26.2171 36.9934 26.9457 36.0631 27.6756C35.4491 28.1534 35.1794 29.0006 35.4126 29.6901C35.6962 30.5284 36.5623 30.7591 37.3023 30.1805C38.2528 29.4544 39.1957 28.7119 40.1488 27.9706C40.5509 27.6567 41.0224 27.7399 41.2304 28.1471C41.4497 28.5568 41.301 29.148 40.8988 29.4619C39.9193 30.2297 38.955 31.0302 37.9528 31.7475C36.8131 32.5631 35.7151 32.5997 34.7583 31.8433C33.7939 31.0692 33.5405 29.8817 33.8242 28.5278C34.0914 27.5723 34.515 26.8297 35.1617 26.2952L35.1642 26.2965Z",
    fill: "#E8F2FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2541 27.3251C38.2138 26.9469 38.3474 26.6166 38.6311 26.3582C38.7105 26.2801 38.8075 26.2196 38.8958 26.1427C40.0883 25.2123 41.2796 24.282 42.4722 23.3516C42.8945 23.0415 43.3685 23.1096 43.5778 23.518C43.787 23.9265 43.661 24.5051 43.2601 24.8202C41.978 25.8275 40.6997 26.8196 39.4076 27.8243C39.2185 27.9756 39.0269 28.0185 38.7231 27.9655C38.5037 27.9264 38.3045 27.7058 38.2529 27.3264L38.2541 27.3251Z",
    fill: "#E8F2FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6673 14.2493L14.6018 7.23014C14.4556 6.97801 14.1341 6.89229 13.882 7.03726L9.83156 9.37195C9.47985 9.57491 9.47985 10.0829 9.83156 10.2859L11.0203 10.9717V14.0325L9.85047 13.3568C9.67902 13.2585 9.46471 13.3808 9.46345 13.5787L9.46094 13.9909C9.46094 14.0829 9.50884 14.1687 9.58826 14.2153L18.0446 19.1494C18.216 19.249 18.4303 19.1267 18.4328 18.9288L18.4366 18.4636C18.4366 18.3703 18.3887 18.2846 18.308 18.238L17.2302 17.6152V14.5544L17.9488 14.9692C18.4165 15.2389 18.9396 14.7158 18.6698 14.2481L18.6673 14.2493ZM14.8262 13.1942V16.255L13.3412 15.394V12.3332L14.8262 13.1942ZM11.8524 11.452L12.5079 11.8516V14.9124L11.8524 14.5128V11.452ZM16.3957 17.1362L15.6595 16.7366V13.6757L16.3957 14.0754V17.1362Z",
    fill: "#E8F2FF",
    stroke: "#4095FC",
    strokeWidth: 0.252126,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.46248 15.1331L9.45996 15.5453C9.45996 15.6373 9.50787 15.723 9.58729 15.7697L18.0436 20.7038C18.215 20.8034 18.4293 20.6811 18.4319 20.4832L18.4357 20.018C18.4357 19.9247 18.3877 19.839 18.3071 19.7923L9.84949 14.9099C9.67805 14.8116 9.46375 14.9339 9.46248 15.1318V15.1331Z",
    fill: "#E8F2FF",
    stroke: "#4095FC",
    strokeWidth: 0.378189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7405 61.54V56.4673C40.7405 56.0626 41.1792 55.8092 41.5297 56.0122L49.4439 60.582C49.8322 60.8064 50.0717 61.2211 50.0717 61.6686V66.3203C50.0717 66.725 49.633 66.9784 49.2826 66.7754L41.0027 61.9951C40.8401 61.9006 40.7393 61.7279 40.7393 61.54H40.7405Z",
    fill: "#E8F2FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0806 63.3527L40.752 58.0253V56.8037L50.0806 62.1311V63.3527Z",
    fill: "#41DCEC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7026 38.4209L11.6941 40.4644C10.615 40.9044 10.586 42.0591 11.6424 42.5293L16.6509 44.7606C17.7073 45.2308 19.0449 44.6598 19.0449 43.7395V39.4647C19.0449 38.5634 17.759 37.991 16.7039 38.4209H16.7026Z",
    fill: "#E8F2FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4613 45.1466C17.1537 45.1466 16.8448 45.0848 16.5612 44.9587L11.5515 42.7274C10.9779 42.4715 10.64 42.0101 10.6476 41.4907C10.6564 40.965 11.0157 40.5062 11.6094 40.2641L16.6192 38.2207C17.281 37.9509 18.074 38.0215 18.64 38.4022C19.0383 38.6707 19.259 39.0476 19.259 39.4636V43.7384C19.259 44.1582 19.0257 44.5515 18.6173 44.815C18.2807 45.0331 17.8723 45.1453 17.46 45.1453L17.4613 45.1466ZM17.4588 38.4929C17.2281 38.4929 16.9961 38.5358 16.7831 38.6215L11.7733 40.665C11.3447 40.8402 11.0863 41.1504 11.0812 41.4983C11.0762 41.8374 11.3182 42.15 11.7279 42.3328L16.7377 44.5641C17.2609 44.7974 17.9227 44.7532 18.3828 44.4545C18.5492 44.3473 18.8266 44.1103 18.8266 43.7397V39.4649C18.8266 39.1964 18.6753 38.9468 18.3992 38.7615C18.1357 38.5837 17.7979 38.4929 17.4575 38.4929H17.4588Z",
    fill: "#4095FC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6367 49.6788V41.7116C10.6367 40.8027 11.6263 40.2392 12.4092 40.7031L22.556 46.7314C22.9115 46.9432 23.1296 47.3265 23.1296 47.7399V55.5382C23.1296 56.4408 22.1526 57.0056 21.3697 56.5543L11.2229 50.6949C10.8599 50.4856 10.6367 50.0986 10.6367 49.6788Z",
    fill: "#E8F2FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9589 56.9286C21.7206 56.9286 21.4811 56.8656 21.2643 56.7408L11.1175 50.8814C10.6888 50.6343 10.4229 50.1729 10.4229 49.6787V41.7115C10.4229 41.206 10.6851 40.7547 11.125 40.5038C11.565 40.2542 12.0869 40.258 12.5218 40.5164L22.6686 46.5448C23.0884 46.7944 23.3481 47.252 23.3481 47.7399V55.5381C23.3481 56.0399 23.0884 56.4899 22.6535 56.742C22.4354 56.8681 22.1971 56.9299 21.9589 56.9299V56.9286ZM11.8121 40.7534C11.6494 40.7534 11.4868 40.7963 11.3381 40.8808C11.0355 41.0535 10.854 41.3636 10.854 41.7128V49.68C10.854 50.0203 11.0368 50.338 11.3318 50.5082L21.4786 56.3676C21.7786 56.5403 22.1354 56.5403 22.4354 56.3676C22.7354 56.1949 22.9132 55.8848 22.9132 55.5394V47.7411C22.9132 47.4058 22.7342 47.0906 22.4455 46.9192L12.2987 40.8909C12.1461 40.8001 11.9785 40.7547 11.8108 40.7547L11.8121 40.7534Z",
    fill: "#4095FC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7382 50.8537L24.6919 52.606C24.9452 52.756 25.1003 53.0295 25.1003 53.3245V54.0166C25.1003 54.6545 24.4133 55.0566 23.8561 54.744L20.91 53.0863C20.649 52.94 20.4864 52.6652 20.4839 52.3652L20.4776 51.5798C20.4725 50.9293 21.1785 50.5234 21.7382 50.855V50.8537Z",
    fill: "#E8F2FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2651 55.122C24.0797 55.122 23.8932 55.0741 23.723 54.9783L20.7769 53.3206C20.4327 53.1264 20.2172 52.7609 20.2134 52.3663L20.2071 51.5809C20.2033 51.1762 20.4113 50.8144 20.7618 50.614C21.1122 50.4123 21.5295 50.4148 21.8762 50.6216L24.8298 52.3738C25.1639 52.5718 25.3706 52.9361 25.3706 53.3244V54.0164C25.3706 54.4135 25.1664 54.7703 24.8235 54.9707C24.6495 55.0729 24.4579 55.1233 24.2651 55.1233V55.122ZM21.3114 51.0061C21.2143 51.0061 21.1185 51.0313 21.0303 51.0817C20.8513 51.1851 20.7454 51.3691 20.7479 51.5759L20.7542 52.3612C20.7555 52.5629 20.8664 52.7495 21.0416 52.8478L23.9877 54.5056C24.1642 54.6052 24.3747 54.6039 24.5487 54.5005C24.7239 54.3984 24.8286 54.2156 24.8286 54.0139V53.3218C24.8286 53.1239 24.7227 52.9374 24.5525 52.8365L21.5988 51.0842C21.5093 51.0313 21.4097 51.0048 21.3114 51.0048V51.0061Z",
    fill: "#4095FC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9516 46.5385C17.9138 46.5385 17.876 46.5284 17.842 46.5083L11.6977 42.8789C11.5943 42.8184 11.5602 42.686 11.6207 42.5827C11.6813 42.4793 11.8136 42.4452 11.917 42.5058L18.0613 46.1351C18.1647 46.1956 18.1987 46.328 18.1382 46.4314C18.0979 46.4994 18.026 46.5373 17.9516 46.5373V46.5385Z",
    fill: "#4095FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_488_1113",
    x1: -2.47588,
    y1: 76.4141,
    x2: 63.2055,
    y2: 52.5768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0633C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#063DD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#0757E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0769F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0774FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0878FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_488_1113",
    x1: 3.96389,
    y1: 53.6706,
    x2: 28.6445,
    y2: 44.7126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0871F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_488_1113",
    x1: 23.9301,
    y1: 56.3332,
    x2: 35.6703,
    y2: 52.0722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#132BAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C34BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0739CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#063BCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_488_1113",
    x1: 26.9727,
    y1: 31.0425,
    x2: 51.6533,
    y2: 22.0844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0871F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_488_1113",
    x1: 46.9389,
    y1: 33.705,
    x2: 58.6791,
    y2: 29.4441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#132BAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C34BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0739CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#063BCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_488_1113",
    x1: 5.20962,
    y1: 16.5472,
    x2: 20.9789,
    y2: 10.8252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0871F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_488_1113",
    x1: 17.9669,
    y1: 18.2489,
    x2: 25.4677,
    y2: 15.5259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#132BAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C34BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0739CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#063BCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_488_1113",
    x1: 36.3463,
    y1: 64.703,
    x2: 52.1156,
    y2: 58.9809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0871F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09B2EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_488_1113",
    x1: 49.1037,
    y1: 66.4044,
    x2: 56.6044,
    y2: 63.6815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#132BAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#0C34BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#0739CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#063BCE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTipsBag);
export default __webpack_public_path__ + "static/media/tips-bag.b9a25730cd3b823b6386cfdb97ae1d01.svg";
export { ForwardRef as ReactComponent };